<script>
  import Vue from 'vue';
  import Checkbox from '../../../components/modals/New_RoundTable/Components/Checkbox.vue';
  export default Vue.extend({
    components: {
      Checkbox,
    },
    props: {
      provider: {
        type: Object,
        default() {
          return {};
        },
      },
      courses: {
        type: Array,
        default() {
          return [];
        },
      },
    },
    data() {
      return {
        selectedCourse: null,
      };
    },
    methods: {
      handleSelectCourse(course) {
        if (this.selectedCourse !== course) {
          this.selectedCourse = course;
          this.$emit("selectedCourses", this.selectedCourse);
        }
      },
    },
  });
</script>
<template>
  <div class="flex flex-col space-y-5 bg-gray-100 rounded-md py-4 px-5">
    <div class="flex items-center">
      <img
        v-if="provider.name === 'Google Classroom'"
        :src="provider.icon_url"
        class="rounded-full"
        width="30px"
        height="30px"
      />
      <img
        v-else
        :src="`/static/integrations/${provider.name}.png`"
        class="rounded-full"
        width="30px"
        height="30px"
      />
      <span class="px-3 text-base font-poppins font-semibold">
        {{ provider.name }}
      </span>
    </div>
    <div class="flex flex-grow h-full flex-col space-y-4">
      <p class="text-sm text-gray-500">
        Which {{ provider.name }} class do you want to sync to to your Parlay account ?
      </p>
      <div class="flex flex-col space-y-2 h-full md:max-h-80 overflow-y-auto">
        <li
          v-for="(course, index) in courses"
          @click="handleSelectCourse(course)"
          class="flex items-center justify-between bg-white rounded-md w-full hover:border-primary-dark border border-solid cursor-pointer border-white px-4 py-2.5"
          :class="{'border-primary-dark': selectedCourse === course}"
        >
          <span>{{ course.name }}</span>
          <Checkbox :is_checked="selectedCourse === course" />
        </li>
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// createCoursesFromLms.vue?9734ff4c